import { create } from 'zustand'

export type ToastKind = 'success' | 'error' | 'info'

export type ToastItem = {
  id: number
  kind: ToastKind
  title: string
  description?: string
}

type ToastState = {
  toasts: ToastItem[]
  push(kind: ToastKind, title: string, description?: string): void
  dismiss(id: number): void
}

let nextId = 1

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (kind, title, description) => {
    const id = nextId++
    set((state) => ({ toasts: [...state.toasts.slice(-3), { id, kind, title, description }] }))
    window.setTimeout(() => {
      useToastStore.getState().dismiss(id)
    }, 3200)
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}))

export const toast = {
  success: (title: string, description?: string) => useToastStore.getState().push('success', title, description),
  error: (title: string, description?: string) => useToastStore.getState().push('error', title, description),
  info: (title: string, description?: string) => useToastStore.getState().push('info', title, description),
}
